import { remoteAuthCheck } from './check';

/**
 * Separate file to make mocking easier in tests.
 */
export const prefetchedAuthCheckPromise = remoteAuthCheck();
